/*
 * 名刺登録（api create）
 */
import { apiCreate } from '@/actions/ApiBaseActions';
export const API_CARD_UPLOAD = 'API_CARD_UPLOAD';
/**
 * 名刺登録 送信
 * @param data
 * @param meta
 * @returns
 */
export const apiCardUpload = ({ json, path: { token } }, meta) => apiCreate(API_CARD_UPLOAD, `/card/${token}`, json, Object.assign(Object.assign({}, meta), { isSnakeCase: true }));
